import { app } from "@/main";

/**
 * initial state
 * 사용 예) this.$store.state.language.lang
 */
const state = {
  lang: ""
};

/**
 * getters
 * 사용 예) this.$store.getters['language/getLanguage'];
 */
const getters = {};

/**
 * mutations
 * 사용 예) this.$store.commit('language/changeLanguage','korean');
 */
const mutations = {
  changeLanguage: function(state, payload) {
    state.lang = payload; // 활용하지 않음
    app.$i18n.locale = payload;
    localStorage.setItem("lang", payload);
  }
};

/**
 * actions
 * 사용 예) this.$store.dispatch('language/changeLanguage');
 */
const actions = {};

export default {
  namespaced: true, // 각 모듈들의 속성명이 유일하도록 namespaced: true를 꼭 추가해줘야 합니다.
  state,
  getters,
  mutations,
  actions
};
